export enum CustomFieldDataType {
  Text = 1,
  Number = 2,
  YesNo = 3,
  Date = 4,
  Time = 5,
  DateTime = 6,
}

export function getCustomFieldDataTypeName(dataTypeId: number): string {
  switch (dataTypeId) {
    case CustomFieldDataType.Date:
      return 'Date';
    case CustomFieldDataType.YesNo:
      return 'Yes/No';
    case CustomFieldDataType.Number:
      return 'Number';
    case CustomFieldDataType.Time:
      return 'Time';
    case CustomFieldDataType.DateTime:
      return 'Date/Time';
    case CustomFieldDataType.Text:
    default:
      return 'Text';
  }
}
